// extracted by mini-css-extract-plugin
export default {"Trigger":"FileActionsMenu_Trigger__pYP57","Dropdown":"FileActionsMenu_Dropdown__xL02f","Item":"FileActionsMenu_Item__xSOlK"};